import {instance} from "./instance";
import {compactChatFile} from "../services/chatFile";

export const send_file_to_parse = async (file: File, app_type: string) => {
    if (file) {
        const formData = new FormData();
        formData.append('file', await compactChatFile(file, app_type));
        formData.append('app_type', app_type);
        return instance.post('/file/parseFile', formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        })
    } else {
        return null
    }

}
